import moment from "moment"

export const APP_DATE_FORMAT = "MM/DD/YYYY"
export const APP_INPUTS_DATE_FORMAT = ["m", "d", "Y"]
export const DATABASE_DATE_FORMAT = "YYYY-MM-DD"

export function formatLongDate(value) {
  return moment(value).format("ll")
}

export function formatIntradayLatestPriceTimestamp(value) {
  return moment(value).format("ll. [Latest Price] h:mm A")
}

// A batch-trend chart has multiple same-day points, so none can claim to be "the latest price".
export function formatIntradayBatchTimestamp(value) {
  return moment(value).format("ll. h:mm A")
}

// Picked per point via `batchId`, not chart-level mode alone — a merged series mixes both point types.
export function formatIntradayHeaderDate(intradayChartMode, value, batchId) {
  if (intradayChartMode === "none") return formatLongDate(value)
  if (batchId != null) return formatIntradayBatchTimestamp(value)
  return formatIntradayLatestPriceTimestamp(value)
}

export function formatShortDate(value) {
  return moment(value).format("MMM D")
}

export function formatNiceShortDate(value) {
  return moment(value).calendar()
}
